module.exports = __webpack_public_path__ + "img/coffee-beans.161f73a0.png";